import { useEffect, useState } from 'react';
import { handleHttpError } from '@/common/http/errorHandler';
import * as projectClient from '../../models/projects/projectClient';
import { ANGEL_TYPE, type Project } from '../../models/projects/project';

// エンジェル税制対象の案件を先頭から limit 件取る（シミュレーターのページとエンジェル税制 LP の案件一覧）。
// 戻り値の null は取得前。一覧はページの付随情報なので、取得に失敗しても利用者には通知せず、空にして「対象案件なし」と同じ表示にする。
// API（angel_tax=1）が絞るが、対象外が混ざらないことを画面側でも保証するため angel_type で除く
export function useAngelTaxProjects(limit: number): Project[] | null {
  const [projects, setProjects] = useState<Project[] | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    projectClient
      .fetchAngelTax(limit, controller.signal)
      .then(fetched =>
        setProjects(
          fetched.filter(project => project.angelType !== ANGEL_TYPE.none),
        ),
      )
      .catch((error: unknown) => {
        if (controller.signal.aborted) return;
        setProjects([]);
        handleHttpError(error, { toast: false });
      });
    return () => controller.abort();
  }, [limit]);

  return projects;
}
